import React from 'react';
import { Points } from 'components/Points/Points';
import InfoTooltip from './InfoTooltip';
import './MetricBox.css';

interface MetricBoxProps {
  /** The value to display (can be number, or null for N/A display) */
  value: number | null;

  /** The label text below the value */
  label: string;

  /** The type of value determines formatting */
  type: 'number' | 'points' | 'percentage';

  /** Optional loading state */
  isLoading?: boolean;

  /** Optional tooltip text to explain the metric */
  tooltip?: string;
}

const MetricBox: React.FC<MetricBoxProps> = ({ value, label, type, isLoading = false, tooltip }) => {
  const formatter = new Intl.NumberFormat('en-US');

  const renderValue = () => {
    // Handle null values (e.g., economy health score in v1)
    if (value === null) {
      return <div className="metric-value">🏗️</div>;
    }

    // Handle points type (uses Points component with coin icon)
    if (type === 'points') {
      return <Points points={value} type="big" isLoading={isLoading} />;
    }

    // Handle percentage type (append %)
    if (type === 'percentage') {
      return <div className="metric-value">{value}%</div>;
    }

    // Handle number type (format with commas)
    return <div className="metric-value">{formatter.format(value)}</div>;
  };

  return (
    <div className="metric-box">
      <div className="metric-value-container">{renderValue()}</div>
      <div className="metric-label">
        {label}
        {tooltip && <InfoTooltip text={tooltip} />}
      </div>
    </div>
  );
};

export default MetricBox;
